import { Flex, Heading } from '@chakra-ui/react';

import ATOM_ICON from '@/assets/images/presentation/atom-icon.png';
import ATTENDANCE_ICON from '@/assets/images/presentation/attendance-icon.png';
import BOX_OPEN_ICON from '@/assets/images/presentation/box-open-icon.png';
import CONTINUED_ENGAGEMENT from '@/assets/images/presentation/continued-engagement-icon.png';
import GROUP_CHATTING_ICON from '@/assets/images/presentation/group-chatting.png';
import MAN_SHOWING_DIAGRAMS_ICON from '@/assets/images/presentation/man-showing-diagrams.png';
import MAN_WRITING_ICON from '@/assets/images/presentation/man-writing.png';

import { WhyReasons } from '@/components/ui/features/presentation/PresentationReviews/components/WhyReasons';

export const WhatDoWeOffer = () => {
  return (
    <Flex mt={12} flexDirection="column">
      <Heading textAlign="center" mb={9} as="h3" fontSize="3xl">
        What You’ll Receive for $19.95 per Presentation
      </Heading>
      <Flex
        gap={8}
        flexWrap="wrap"
        flexDirection={{ base: 'column', sm: 'row' }}
        alignItems="center"
        justifyContent="center"
      >
        <WhyReasons
          w="312px"
          src={ATTENDANCE_ICON}
          alt="Global Reach"
          title="Global Reach"
          description="Make your work accessible to thousands of researchers, institutions, and potential collaborators around the world."
        />
        <WhyReasons
          w="312px"
          src={ATOM_ICON}
          alt="Improved Discoverability"
          title="Improved Discoverability"
          description="Your presentation will be indexed by search engines and academic databases, increasing organic exposure."
        />
        <WhyReasons
          w="312px"
          src={MAN_WRITING_ICON}
          alt="Citable, Permanent Record"
          title="Citable, Permanent Record"
          description="Every submission receives a DOI and persistent URL, enabling formal citation and long-term scholarly impact."
        />
        <WhyReasons
          w="312px"
          src={CONTINUED_ENGAGEMENT}
          alt="Facilitate New Collaborations"
          title="Facilitate New Collaborations"
          description="Let others find and engage with your work — including contacting you directly for follow-up or partnership."
        />
        <WhyReasons
          w="312px"
          src={MAN_SHOWING_DIAGRAMS_ICON}
          alt="Impact Analytics"
          title="Impact Analytics"
          description="Monitor engagement through view counts, geographic reach, and more."
        />
        <WhyReasons
          w="312px"
          src={ATTENDANCE_ICON}
          alt="Professional Presentation"
          title="Professional Presentation"
          description="Stand out with a high-quality, structured display of your research — tailored for academic audiences, not general video platforms."
        />
        <WhyReasons
          w="312px"
          src={BOX_OPEN_ICON}
          alt="Complete Research Package"
          title="Complete Research Package"
          description="Host your video alongside your paper, slides, abstract, and poster — all in one structured, searchable location."
        />
        <WhyReasons
          w="312px"
          src={GROUP_CHATTING_ICON}
          alt="Academic Credit"
          title="Academic Credit"
          description="Presentations with DOIs can be listed on your CV, linked in your ORCID profile, or included in grant applications."
        />
      </Flex>
    </Flex>
  );
};
